import PropTypes from 'prop-types'
import React from 'react'

import {
    Title,
    RecordingInfo,
    Icon,
    Text,
    CtaTitle,
    InformationWrapper,
} from './styles'

const copy = {
    infoCopy:
        'oh. we’re recording these sessions to improve your experience. please reach out for any clarifications.',
    ctaTitle: 'ready to start?',
}

const Information = ({ isRecording, classTitle }) => {
    const margin = !isRecording ? 3 : 0
    return (
        <InformationWrapper>
            <Title>{classTitle}</Title>
            {isRecording && (
                <RecordingInfo>
                    <Icon />
                    <Text>{copy.infoCopy}</Text>
                </RecordingInfo>
            )}
            <CtaTitle margin={margin}>{copy.ctaTitle}</CtaTitle>
        </InformationWrapper>
    )
}

Information.propTypes = {
    isRecording: PropTypes.bool.isRequired,
    classTitle: PropTypes.string.isRequired,
}

export default Information
